import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "contactWrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Kontakt", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "contactSlogan" }, " Schreiben Sie uns für weitere Informationen oder bei Rückfragen gerne eine Nachricht. ", -1)
const _hoisted_4 = { class: "contactInfoWrapper" }
const _hoisted_5 = {
  key: 0,
  class: "errorText"
}
const _hoisted_6 = {
  key: 0,
  class: "errorText",
  style: {"font-size":"15px"}
}
const _hoisted_7 = { class: "info" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "cardHeader" }, " Kontakt ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "contactLane" }, " Klaus Schneider ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "contactLane" }, " Diemelseestr. 55 ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "contactLane" }, " 34431 Marsberg ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "contactLane" }, " 02991 78290 ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "contactLane" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:mail@sauerland-heu.de" }, "mail@sauerland-heu.de")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "successText"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        class: "form",
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.contactForm,
        "label-width": "95px",
        "label-position": _ctx.labelPosition
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Vorname",
            prop: "first_name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.contactForm.first_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactForm.first_name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Nachname",
            prop: "last_name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.contactForm.last_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactForm.last_name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "E-Mail",
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.contactForm.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactForm.email) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Nachricht",
            prop: "message"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                rows: "10",
                modelValue: _ctx.contactForm.message,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactForm.message) = $event)),
                type: "textarea"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vue_recaptcha, {
                sitekey: "6LdqqrgUAAAAAKq8Opp91goIcoV9nfdvwWicMNRI",
                onVerify: _ctx.verifyCaptcha,
                onExpired: _ctx.captureExpired
              }, null, 8, ["onVerify", "onExpired"]),
              (_ctx.showCaptchaWarning)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Bitte bestätigen Sie, dass Sie kein Roboter sind."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "submitPart" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitForm(_ctx.formRef)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Absenden")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.showFormError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Beim Absenden ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["rules", "model", "label-position"])), [
        [_directive_loading, _ctx.formLoading]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_card, { class: "card" }, {
          header: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx(() => [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.showSuccess)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Vielen Dank für Ihre Nachricht. Wir werden uns so schnell wie möglich bei Ihnen melden."))
      : _createCommentVNode("", true),
    _hoisted_15
  ]))
}